import styles from "./signupblock.module.css";
import SignupButton from "../SignupButton";
import LoginWithGoogleButton from "../LoginWithGoogleButton";
import LoginWithFacebookButton from "../LoginWithFacebookButton";
import LoginWithTiktokButton from "../LoginWithTiktokButton";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import SignupVerifyBlock from "../SignupVerifyBlock";
import ForceZaloOAuthBlock from "../ForceZaloOAuthBlock";
import InputEmail from "../InputEmail";
import InputPhone from "../InputPhone";

export default function SignupBlock() {
  const { t } = useTranslation();
  const [emailValue, setEmailValue] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [userId, setUserId] = useState("");

  const [showOTPForm, setShowOTPForm] = useState(false);
  const [showZaloOAuth, setShowZaloOAuth] = useState(false);

  return showZaloOAuth ? (
    userId !== "" ? (
      <ForceZaloOAuthBlock userId={userId} phoneNumber={phoneValue} />
    ) : (
      (console.error("User ID is empty"), null)
    )
  ) : (
    <div className={styles.signupBlock}>
      <h2 className={styles.signupText}>{t("signup")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputPhone
            phoneValue={phoneValue}
            setPhoneValue={setPhoneValue}
            setErrorPhone={setErrorPhone}
            errorPhone={errorPhone}
          />
        </div>
        <span>{t(errorPhone)}</span>
      </div>
      <p className={styles.tosInfo}>
        {t("agreement")} <a href="terms-of-service">{t("terms")}</a> &{" "}
        <a href="privacy-policy">{t("privacy")}</a>
      </p>
      <div className={`col-12 ${styles.signupButtonContainer}`}>
        <SignupButton
          phoneValue={phoneValue}
          setErrorPhone={setErrorPhone}
          errorPhone={errorPhone}
          setShowZaloOAuth={setShowZaloOAuth}
          setUserId={setUserId}
        />
      </div>
      {/* <div className={`col-12 ${styles.hrContainer}`}>
        <hr className={styles.leftHr} />
        <span className={styles.hrText}>{t("or")}</span>
        <hr className={styles.rightHr} />
      </div>
      <div className={`col-12 ${styles.loginWithBlock}`}>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithGoogleButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithFacebookButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithTiktokButton />
        </div>
      </div> */}
      <p className={styles.tologinPage}>
        {t("have_account_already")} <a href="/login">{t("login")}</a>
      </p>
    </div>
  );
}
